import React from "react";

export default function DetailsSectionLabel({ label, isFirst = false }) {
  return (
    <>
      <h4
        className={`text-mchenry-orange ${
          isFirst ? "" : "mt-4"
        } font-bold text-sm`}
      >
        {label}
      </h4>
      <hr className="mb-2 mt-1" />
    </>
  );
}
